import React, { useState } from 'react';
import { Phone } from 'lucide-react';
import { siteInfo } from '../data/mock';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Button } from '../components/ui/button';

const ContattaciSection = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefono: '',
    messaggio: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setFormData({ nome: '', email: '', telefono: '', messaggio: '' });
  };

  return (
    <div 
      className="min-h-screen pt-20 pb-12 bg-cover bg-center bg-fixed relative"
      style={{
        backgroundImage: `url('${siteInfo.dashboardImage}')`
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-white/90" />
      
      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-8">
        {/* Title */}
        <div className="mb-10 text-center">
          <h2 className="font-cinzel text-2xl md:text-3xl text-amber-800 tracking-wide">
            Contattaci
          </h2>
          <div className="w-24 h-0.5 bg-amber-700 mt-4 mx-auto" />
          <p className="text-stone-600 mt-4">Per info e preventivi</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4 bg-white/70 backdrop-blur-sm p-6 md:p-8 rounded-xl shadow-lg border border-amber-100">
          <Input
            type="text"
            name="nome"
            placeholder="Nome"
            value={formData.nome}
            onChange={handleChange}
            required
            className="bg-white border-amber-200 rounded-lg px-4 py-3 text-stone-700 placeholder:text-stone-400 focus:border-amber-500 focus:ring-amber-500"
          />
          <Input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="bg-white border-amber-200 rounded-lg px-4 py-3 text-stone-700 placeholder:text-stone-400 focus:border-amber-500 focus:ring-amber-500"
          />
          <Input
            type="tel"
            name="telefono"
            placeholder="Telefono"
            value={formData.telefono}
            onChange={handleChange}
            className="bg-white border-amber-200 rounded-lg px-4 py-3 text-stone-700 placeholder:text-stone-400 focus:border-amber-500 focus:ring-amber-500"
          />
          <Textarea
            name="messaggio"
            placeholder="Messaggio"
            value={formData.messaggio}
            onChange={handleChange}
            required
            rows={5}
            className="bg-white border-amber-200 rounded-lg px-4 py-4 text-stone-700 placeholder:text-stone-400 focus:border-amber-500 focus:ring-amber-500 resize-none"
          />
          
          <div className="flex justify-center pt-2">
            <Button
              type="submit"
              className="bg-amber-700 hover:bg-amber-800 text-white px-10 py-3 rounded-lg tracking-wider uppercase text-sm font-medium shadow-md hover:shadow-lg transition-all"
            >
              {submitted ? 'Inviato!' : 'Invia'}
            </Button>
          </div>
        </form>

        {/* Phone Section */}
        <div className="mt-10 text-center">
          <p className="text-stone-600 text-lg mb-4">Oppure chiamaci al</p>
          <a 
            href={`tel:${siteInfo.phone}`}
            className="inline-flex items-center gap-3 px-6 py-3 bg-white border-2 border-amber-700 rounded-lg text-amber-800 hover:bg-amber-50 transition-colors text-lg font-medium"
          >
            <Phone className="w-5 h-5" />
            {siteInfo.phone}
          </a>
        </div>

        {/* Logo Image */}
        <div className="mt-12 flex justify-center">
          <img 
            src={siteInfo.logoFull} 
            alt="ARKI - Opere In Pietra"
            className="max-w-xs md:max-w-sm w-full h-auto rounded-xl shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default ContattaciSection;
